import { fromUnixToUtcDate } from "../../utils/unix-timestamp";
import AvatarCustom from "../AvatarCustom/AvatarCustom";
import React from "react";


interface IPetPlanCard {
  name: string;
  breedName: string;
  image: string;
  birthdate:string;
  retiredOn:string;
  isWellnessplan: boolean;
}
const PastPetCard = ({
  name,
  breedName,
  image,
  birthdate,
  retiredOn,
  isWellnessplan,
}: IPetPlanCard) => {
  return (

    <div className="bg-white rounded-xl flex flex-col gap-4 shadow px-0 py-3">
      <div className="flex gap-3 px-4 py-2">
        <div>
          <AvatarCustom
            image={image && image}
            width={70}
            height={70}
            name={name}
            isWellnessMember={isWellnessplan}
          />
        </div>
        <div className="flex flex-col gap-0.5">
          <div className="text-xl font-semibold capitalize">{name}</div>
          <div className="flex flex-col gap-1">
            <div className="text-sm">Birthday:{" "}
              <span className="font-semibold text-xs capitalize">
                {(birthdate && birthdate !== "0") ? fromUnixToUtcDate(parseInt(birthdate)) : "n/a"}</span></div>
            <div className="text-sm">Breed:{" "}
              <span className="font-semibold capitalize">{breedName ? breedName : "Other"}</span></div>
            <div className="text-sm text-gray-1">Account Closed:{" "}
              <span className="capitalize  text-xs">{retiredOn ? fromUnixToUtcDate(parseInt(retiredOn)) : "n/a"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PastPetCard;
